<template lang="pug">
.request-reply-input-modal
  b-modal(v-model="_modalShow" size="lg" title="" no-close-on-backdrop no-close-on-esc @ok="onReply" @cancel="cancel")
    .register-body(v-if="request")
      FormInputRadio(v-if="request.replyAcceptance == true" v-model="acceptance" key-name="受け入れ可否" name="acceptance"
        :options="_acceptanceOptions" :validation-rules="{ required: true }" required)
      FormTextarea(
        v-model="messageText"
        key-name="返信内容" name="message-text" placeholder="返信内容をご記載ください。"
        :validation-rules="{ required: true, max: 1000 }" :maxlength="1000"
        :styles="{ maxWidth: '600px', width: '600px', minHeight: '160px' }" required)

    template(#modal-footer="{ ok, cancel }")
      ValidationAlert(v-model="showValidationAlert")
      .buttons.m-0
        button.btn.modal-ok-btn(type="button" @click="ok()") 送信
        button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { BvModalEvent } from "bootstrap-vue";

import { OtherOfficeAcceptanceRequestsGetModel } from "@/commons/services/OtherOfficeAcceptanceRequests";

import { Acceptance } from "@/commons/services/OtherOfficeAcceptanceRequestReplies";

import FormInputRadio from "@/pc/components/forms/FormInputRadio.vue";
import FormTextarea from "@/pc/components/forms/FormTextarea.vue";
import ValidationAlert from "@/pc/basics/ValidationAlertByValidator.vue";

/**
 * ### リクエスト返信入力モーダル
 */
@Component({
  components: {
    FormTextarea,
    FormInputRadio,
    ValidationAlert
  },
  $_veeValidate: { validator: "new" }
})
export default class RequestReplyInputModal extends Vue {
  /** モーダル表示可否 */
  @Prop()
  value!: boolean;
  /** 表示対象のリクエスト */
  @Prop()
  request!: OtherOfficeAcceptanceRequestsGetModel;

  /** 受け入れ可否 */
  acceptance: Acceptance | null = null;
  /** 返信内容 */
  messageText: string = "";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  get _modalShow(): boolean {
    return this.value;
  }

  set _modalShow(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }

  get _acceptanceOptions(): Array<{ value: string; label: string }> {
    return [
      { value: Acceptance.POSSIBLE, label: "受け入れ可" },
      { value: Acceptance.NEED_CONSULTATION, label: "詳細相談希望" },
      { value: Acceptance.NOT_POSSIBLE, label: "受け入れ不可" }
    ];
  }

  /** ### 送信ボタン押下処理 */
  async onReply(modalEvent: BvModalEvent): Promise<void> {
    modalEvent.preventDefault();

    const validationResult: boolean = await this.$validator.validateAll();
    if (validationResult) {
      this.showValidationAlert = false;
      this.$emit("onReply", { acceptance: this.acceptance, messageText: this.messageText });
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /** ### キャンセルボタン押下処理 */
  cancel(): void {
    this.initialize();
    return;
  }

  /** ### 入力値を初期化する */
  public initialize(): void {
    this.acceptance = null;
    this.messageText = "";
    return;
  }
}
</script>
